import React from 'react';

const TimeStep = ({ bookingSettings, onTimeSelect, date, getDiscountForTime, selectedEvent }) => {
    
    // 1. Intervalo alterado para 15 minutos por defeito
    const generateSlots = (start, end, interval = 15) => {
        const times = [];
        let current = parseInt(start.split(':')[0]) * 60 + parseInt(start.split(':')[1]);
        const endMinutes = parseInt(end.split(':')[0]) * 60 + parseInt(end.split(':')[1]);
        while (current <= endMinutes) {
            const h = Math.floor(current / 60);
            const m = current % 60;
            times.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
            current += interval;
        }
        return times;
    };

    const renderTimeButton = (time, type) => {
        let bestDiscount = 0;
        if (getDiscountForTime) bestDiscount = getDiscountForTime(date, time);
        
        // 2. Lógica para esconder horas passadas
        const now = new Date();
        const todayStr = now.toISOString().split('T')[0];
        const currentMinutes = now.getHours() * 60 + now.getMinutes();
        
        const [slotH, slotM] = time.split(':').map(Number);
        const slotMinutes = slotH * 60 + slotM;

        // Se for hoje e o horário for anterior ou igual à hora atual, fica indisponível
        const isPast = (date === todayStr) && (slotMinutes <= currentMinutes);
        const isAvailable = bestDiscount !== -1 && !isPast; 

        return (
            <button
                key={time}
                type="button" 
                disabled={!isAvailable}
                onClick={() => onTimeSelect(time)}
                style={{
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '56px',
                    borderRadius: '8px',
                    border: isAvailable ? '1px solid #e5e7eb' : '1px solid #f3f4f6',
                    backgroundColor: isAvailable ? 'white' : '#f9fafb',
                    color: isAvailable ? '#374151' : '#d1d5db',
                    cursor: isAvailable ? 'pointer' : 'not-allowed',
                    overflow: 'visible',
                    zIndex: 10,
                    width: '100%',
                    boxShadow: isAvailable ? '0 1px 2px rgba(0,0,0,0.05)' : 'none',
                    transition: 'all 0.2s',
                    opacity: isPast ? 0.5 : 1 // Diferencia visualmente horas passadas
                }}
                className={isAvailable ? 'hover:border-amber-500 hover:shadow-md group' : ''}
            >
                <span className="font-bold text-lg z-10">{time}</span>

                {isAvailable && bestDiscount > 0 && (
                     <div style={{
                        position: 'absolute',
                        top: '-10px',
                        right: '-6px',
                        backgroundColor: '#f59e0b',
                        color: 'white',
                        fontSize: '9px',
                        fontWeight: 'bold',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        zIndex: 50,
                        border: '1px solid white',
                        lineHeight: 1,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        whiteSpace: 'nowrap'
                     }}>
                        Até -{bestDiscount}%
                    </div>
                )}
            </button>
        );
    };

    const renderService = (serviceKey, serviceName) => {
        if (!bookingSettings?.horarios) return null;
        const serviceHorarios = bookingSettings.horarios[serviceKey];
        if (!serviceHorarios) return null;

        const startHour = serviceHorarios?.horarioCompleto?.inicio || "12:00";
        const endHour = serviceHorarios?.horarioCompleto?.fim || "15:00";
        
        let slots = [];
        if (serviceHorarios.turnosAtivos) {
            const t1Start = serviceHorarios.turno1?.inicio || startHour;
            const t1End = serviceHorarios.turno1?.fim || "13:30";
            const t2Start = serviceHorarios.turno2?.inicio || "13:30";
            const t2End = serviceHorarios.turno2?.fim || endHour;
            slots = [...generateSlots(t1Start, t1End), ...generateSlots(t2Start, t2End)];
        } else {
            slots = generateSlots(startHour, endHour);
        }

        const uniqueSlots = [...new Set(slots)].sort();
        if (uniqueSlots.length === 0) return null;

        return (
            <div className="mb-8 animate-fade-in">
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                    <i className={`fas ${serviceKey === 'almoco' ? 'fa-sun text-amber-500' : 'fa-moon text-indigo-500'} mr-2`}></i>
                    <h4 style={{ fontSize: '16px', fontWeight: 'bold', textTransform: 'capitalize', color: '#4b5563', margin: 0 }}>{serviceName}</h4>
                    <div style={{ flexGrow: 1, borderTop: '1px solid #f3f4f6', marginLeft: '12px' }}></div>
                </div>
                <div className="grid grid-cols-3 sm:grid-cols-4 gap-4" style={{ padding: '10px' }}>
                    {uniqueSlots.map(time => renderTimeButton(time, serviceKey))}
                </div>
            </div>
        );
    };

    return (
        <div>
            {renderService('almoco', 'Almoço')}
            {renderService('jantar', 'Jantar')}
        </div>
    );
};

export default TimeStep;